<template>
  <section class="section-5 wrapper">
    <div class="hd">
      <h2 class="title">
        专属附加权益
      </h2>
    </div>

    <div class="content">
      <div class="content-item">
        <img
          src="~assets/rights-1.png"
          srcset="~assets/rights-1@2x.png 2x"
          alt=""
        >
        <h5>独享20+种类TTPS工具包</h5>
        <p>独家研发防爆仓风控EA、仓位管理EA、K线形态自动识别指标、外汇交易品种强弱检测EA下单面板，一键下单和一键平仓等20+工具</p>
      </div>
      <div class="content-item">
        <img
          src="~assets/rights-2.png"
          srcset="~assets/rights-2@2x.png 2x"
          alt=""
        >
        <h5>1对1交易诊断、独家交易心理测试</h5>
        <p>与TTPS教练团面对面，1人独享3师辅导，进行心理诊断和摆脱交易陋习</p>
      </div>
      <div class="content-item">
        <img
          src="~assets/rights-3.png"
          srcset="~assets/rights-3@2x.png 2x"
          alt=""
        >
        <h5>TTPS-Alpha知识星球、私密交流社区</h5>
        <p>永久线上交流社区，教练和学员每日发布优质交易观点，每周专属策略报告</p>
      </div>
    </div>

    <btn-contact name="B页-专属附加权益-预约咨询" />
  </section>
</template>

<script>
import BtnContact from './BtnContact.vue';

export default {
  components: {
    BtnContact,
  },
};
</script>

<style lang="scss" scoped>
.section-5 {
  padding-top: percentage(140px / $deviceWidth);
  padding-bottom: percentage(100px / $deviceWidth);
  background: url("~assets/Exclusive.png") center top/100% auto no-repeat;
  @include hdpi() {
    background-image: url("~assets/Exclusive@2x.png");
  }

  &.active {
    .content {
      &-item {
        animation: bounceIn .6s .8s both;

        &:nth-of-type(2) {
          animation-delay: .6s;
        }
        &:nth-of-type(3) {
          animation-delay: 1s;
        }
      }
    }
  }

  .title {
    width: percentage(499px / $deviceWidth);
    padding-top: percentage(140px / $deviceWidth);
  }

  .content {
    $contentWidth: 1440px;
    display: flex;
    justify-content: center;
    margin: percentage(64px / $deviceWidth) auto;
    width: percentage($contentWidth / $deviceWidth);
    text-align: center;

    &-item {
      opacity: 0;
      flex: 1;
      padding: 0 2%;

      h5 {
        position: relative;
        margin: percentage(40px / 480px) auto percentage(64px / 480px);
        font-size: 24px;
        color: #3A4047;
        line-height: 28px;

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 0);
          margin-bottom: percentage(-32px / 480px);
          width: 72px;
          height: 3px;
          background-color: #3773CB;
        }
      }

      p {
        margin: 0;
        font-size: 20px;
        line-height: 32px;
        color: #3A4047;
        opacity: .8;
      }
    }
  }

  @include mediaWidth(1440px) {
    .content {
      h5 {
        font-size: 18px;
      }
      p {
        font-size: 16px;
        line-height: 28px;
      }
    }
  }

  @include mediaWidth(1024px) {
    .content {
      width: 85%;
      h5 {
        font-size: 18px;
      }

      p {
        font-size: 16px;
      }
    }
  }

  @include mediaWidth(#{$mbWidth}) {
    padding-top:  percentage(80px / $mbWidth);

    .title {
      width: percentage(309px / $mbWidth);
      padding-top: percentage(87px / $mbWidth);
    }
    .content {
      width: 100%;
      flex-wrap: wrap;
      margin: 0 auto percentage(50px / $mbWidth);

      &-item {
        flex: none;
        width: 50%;
        padding: 0 percentage(30px / $mbWidth);

        img {
          width: percentage(239px / (($mbWidth - 60px) / 2));
        }

        h5 {
          margin: percentage(20px / (($mbWidth - 60px) / 2)) auto percentage(32px / ($mbWidth / 2));
          white-space: normal;
          line-height: 22px;
          &::after {
            content: none;
          }
        }
      }
    }
  }

  @include mediaWidth(528px) {
    .content {
      &-item {
        h5 {
          font-size: 14px;
        }
        p {
          font-size: 12px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
